import {Image} from "antd";
import {useEffect, useState} from "react";
import {useCabStyleImage, useModelSelection} from "../../hook/useModelInfo";
import {useQuoteContext} from "../../contexts/QuoteContext";
import {CategoryIdAssembliesIdMap, MISSING_IMAGE} from "../../api/models";

export const QuoteTruckImage = () => {

  const { quote } = useQuoteContext();

  const [modelInfo] = useModelSelection();
  const [imageUri, setImageUri] = useState<string>();

  const cabFuelImageLst = useCabStyleImage();

  useEffect(() => {
    if ( !quote ) return;

    getTruckImage( quote.selections );
  }, [quote?.id]);

  const getTruckImage = async (selections:CategoryIdAssembliesIdMap) => {

    const [cabStyle, fuelType] = await Promise.all([
      modelInfo.fetchCabStyle( selections ),
      modelInfo.fetchFuelType( selections )
    ]);

    if ( !cabStyle || !fuelType ) return;

    const truckImg = cabFuelImageLst?.filter( cfi => cfi.fuelType === fuelType && cfi.cabStyle === cabStyle ).find(v=>v);

    setImageUri(truckImg?.imageUri);
  }

  return <Image src={imageUri}
    preview={false}
    width={120}
    fallback={MISSING_IMAGE}
  />
}

export default QuoteTruckImage;
